export default __webpack_public_path__ + "static/casino-med-snabba-uttag-god-service-c6709198b8e12528f0ff4be535bd32af.jpg";